import ReactGA from 'react-ga4'
import config from '../config'


// const CATEGORY_USER = 'user'
// const CATEGORY_SEARCH = 'search'

const CATEGORY_FUND = 'fund'
const CATEGORY_FAMILY= 'family'
const CATEGORY_MORNINGSTAR = 'mstar'
const CATEGORY_FFF = 'fff'
const CATEGORY_TOOLKIT= 'toolkit'
const CATEGORY_DOWNLOAD= 'download'

function event(eventProps){
  // console.log('event:',eventProps)
  if( config.gaKey ){
    ReactGA.event( eventProps)
  }
}
function eventToMorningstar(investmentVehicleId){
  return {
    category: CATEGORY_MORNINGSTAR,
    action: 'fund_to_morningstar',
    label: 'investmentVehicleId:'+investmentVehicleId,
  }
}
function eventToFamily(familyName){
  return {
    category: CATEGORY_FAMILY,
    action: 'front_to_family',
    label: 'family:'+familyName,
  }
}
function eventLoadFund(fundId, investmentVehicleId){
  return {
    category: CATEGORY_FUND,
    action: 'fund_searched',
    label: 'fundId:'+fundId+',investmentId:'+ investmentVehicleId,
  }
}
function eventToFamilyPopup(familyName){
  return {
    category: CATEGORY_FAMILY,
    action: 'popup_to_family',
    label: 'family:'+familyName,
  }
}
function eventToFamilyTakeAction(familyName){
  return {
    category: CATEGORY_FAMILY,
    action: 'family_take_action',
    label: 'family:'+familyName,
  }
}
function eventToFFF(fundId,investmentVehicleId){
  return {
    category: CATEGORY_FFF,
    action: 'to_fff',
    label: 'fundId:'+fundId+',investmentId:'+ investmentVehicleId,
  }
}
function eventToToolkit(){
  return {
    category: CATEGORY_TOOLKIT,
    action: 'to_toolkit',
  }
}
function eventDownloadChangelogExcel(datasetName){
  return {
    category: CATEGORY_DOWNLOAD,
    action: 'dl_changelog_excel',
    label: 'dataset:'+datasetName
  }
}

export default {
  event,
  eventToMorningstar,
  eventToFamily,
  eventToFamilyPopup,
  eventLoadFund,
  eventToFamilyTakeAction,
  eventToFFF,
  eventToToolkit,
  eventDownloadChangelogExcel
}
